import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import TextField from '../shared/ppbn-textfield';
import ZipcodeTextfield from '../shared/zipcode-textfield';
import StateSelectField from '../shared/state-select-field';
import EmailChipInput from '../shared/EmailChipInput';

const styles = {
    root: {
        margin: '1rem'
    },
    button: {
        padding: '.75rem',
        margin: '1rem .75rem 0 0'
    },
    name: {
        width: '450px',
    },
    street: {
        width: '450px'
    },
    city: {
        width: '275px'
    },
    notes: {
        margin: '.75rem 0',
        width: '550px'
    },
    editingButton: {
        marginTop: '30px',
        marginRight: '15px'
    }
};

export class CustomerInfoForm extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            customer: {
                id: '',
                disabled: 0,
                name: '',
                street: '',
                city: '',
                state: '',
                zipcode: '',
                notes: '',
                phone: '',
                fax: '',
                emails: []
            }
        }
    }
    
    componentDidMount() {        
        this.setState({customer : this.props.customer});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.customer) {
            this.setState({ customer: nextProps.customer });
        }
    }
    
    handleChange = (event) => {        
        const customer = this.state.customer;
        customer[event.target.id] = event.target.value;
        this.setState({
            nameError: !(!!customer.name && customer.name.length > 0),
            editing : true, // send an event back up
            customer: customer,
        });
    };

    editingButtons(classes) {
        let saveDisabled = this.state.nameError || !this.state.editing;

        return (
            <div className="button-section">
                <Button 
                    className={classNames(classes.button, classes.editingButton, 'cancel')}
                    label='cancel'
                    variant='outlined'
                    color='primary'
                    onClick={() => { this.props.onCancel() }}>Cancel</Button> 
                
                <Button
                    disabled={saveDisabled}
                    variant='contained'
                    className={classNames(classes.button, classes.editingButton, 'save')}
                    color='primary'
                    onClick={ () => this.props.onSave(this.state.customer) }>
                    Save Customer
                </Button>
            </div>
        )
    } 

    textFields(classes) {
        const { customer, errorName } = this.state;
        const { disableEnabled, disableNameField } = this.props;
        return (
            <div>
                <TextField
                    id="name"
                    className={classNames(classes.name, 'foo')}
                    error={!!errorName} // errorName ? "Please Enter a Customer Name" : ""}   
                    value={customer.name || ''}
                    label="Name"
                    max="30"
                    disabled={disableNameField}
                    onChange={(e) => this.handleChange(e)}
                />
                <br/>
                <TextField
                    id="street"
                    className={classNames(classes.street)}
                    value={customer.street || ''}
                    label="Street"
                    onChange={(e) => this.handleChange(e)}
                /><br />
                <TextField
                    id="city"
                    className={classNames(classes.city)}
                    value={customer.city || ''}
                    label="City"
                    onChange={(e) => this.handleChange(e)}
                /><br />       
                <StateSelectField className={classNames(classes.stateSelect)} value={customer.state || ''} onChange={(e) => this.handleChange(e)}/>
                <br />                
                <ZipcodeTextfield 
                    id="zipcode"                    
                    className={classNames(classes.zip)}
                    value={customer.zipcode || ""}                    
                    onChange={(e) => this.handleChange(e)}/>
                <br />
                <TextField
                    id="phone"
                    className={classNames(classes.phone)}
                    type="telephone"
                    label="Phone"
                    onChange={(e) => this.handleChange(e)}
                >
                    <InputMask
                        mask="(999) 999-9999"
                        maskChar=" "
                        value={customer.phone || ''} />
 
                </TextField>
                <br />
                <TextField
                    id="fax"
                    className={classNames(classes.fax)}
                    type="tel"
                    label="Fax"
                    onChange={(e) => this.handleChange(e)}
                >
                    <InputMask
                        mask="(999) 999-9999"
                        maskChar=" "
                        value={customer.fax ? customer.fax : ""} />
                </TextField>
                <EmailChipInput 
                    className={classNames(classes.email)}
                    emails={customer.emails} 
                    onChange={(e) => this.handleChange(e)}/>
                <br />
                <TextField
                    className={classNames(classes.notes, 'notes-textfield')}
                    id="notes"
                    value={customer.notes || ""}
                    label="Notes"
                    multiline={true}
                    fullWidth
                    rows={3}
                    variant="outlined"
                    onChange={(e) => this.handleChange(e)}
                /><br />
                {disableEnabled ? <FormControlLabel
                    id="disabled"
                    label="Disabled"
                    control={<Checkbox
                                checked={customer.disabled === 1}
                                onChange={ event => 
                                    this.handleChange( {
                                        target : { 
                                            id : "disabled",
                                            value : event.target.checked ? 1 : 0
                                        }
                                    } )
                                } 
                            />}
                /> : null}
                <br />
            </div>
        )

    }

    render() {            
        const { classes } = this.props;
        return( 
            <div className={classes.root}>
                {this.textFields(classes)}
                {this.editingButtons(classes)}
            </div>
        )
    }

}

export default withStyles(styles)(CustomerInfoForm);